import {NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenuComponent} from './menu/menu.component';
import {ToastsComponent} from './toast/toast.component';
import {NgbDropdownModule, NgbToastModule, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {ReferentielPipe} from '../pipes/referentiel.pipe';
import {JoinPipe} from '../pipes/join.pipe';
import {ReferentielComponent} from './referentiel/referentiel.component';
import {BackResourcePipe} from '../pipes/back-resource.pipe';
import {AdresseComponent} from './adresse/adresse.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {RouterModule} from '@angular/router';
import {RowItemComponent} from './row-item/row-item.component';
import {CoverComponent} from './cover/cover.component';
import {ExcerptPipe} from '../pipes/excerpt.pipe';
import {CardComponent} from './card/card.component';
import {FilterComponent} from './filter/filter.component';
import {GroupByPipe} from '../pipes/group-by.pipe';
import {FileExtensionPipe} from '../pipes/file-extension.pipe';
import {BreadcrumbComponent} from './breadcrumb/breadcrumb.component';
import {FileIconComponent} from './file-icon/file-icon.component';
import {ContactCardComponent} from './contact-card/contact-card.component';
import {DocumentCardComponent} from './document-card/document-card.component';
import {ProgressIndicatorComponent} from './progress-indicator/progress-indicator.component';
import {TypeofPipe} from '../pipes/typeof.pipe';
import {BypassSecurityTrustUrlPipe} from '../pipes/bypass-security-trust-url.pipe';
import {CircleImageInputComponent} from './circle-image-input/circle-image-input.component';
import {NgbDateToIsoPipe} from '../pipes/ngbdate-to-iso.pipe';
import {DeleteConfirmComponent} from './delete-confirm/delete-confirm.component';
import {VersionComponent} from './version/version.component';
import {NoteEnergieComponent} from './note-energie/note-energie.component';
import {ClasseEnergetiquePipe} from '../pipes/classe-energetique.pipe';
import {UcfirstPipe} from '../pipes/ucfirst.pipe';
import {OpenLocataireConfirmComponent} from './open-locataire-confirm/open-locataire-confirm.component';
import {MenuMobileComponent} from './menu-mobile/menu-mobile.component';
import {NgxMatomoTrackerModule} from 'ngx-matomo-client';
import {FileSizePipe} from '../pipes/filesize.pipe';
import {NousContacterComponent} from './nous-contacter/nous-contacter.component';
import {NgxEditorModule} from 'ngx-editor';
import {ConfirmComponent} from './confirm/confirm.component';
import { OffrePartenaireCardComponent } from './offre-partenaire-card/offre-partenaire-card.component';
import {RowContainerComponent} from "./row-container/row-container.component";
import { BadeauComponent } from './parcours-travaux/badeau/badeau.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    MenuComponent,
    MenuMobileComponent,
    ToastsComponent,
    ReferentielPipe,
    ReferentielComponent,
    BackResourcePipe,
    ExcerptPipe,
    FileSizePipe,
    GroupByPipe,
    JoinPipe,
    FileExtensionPipe,
    TypeofPipe,
    BypassSecurityTrustUrlPipe,
    AdresseComponent,
    RowItemComponent,
    RowContainerComponent,
    CoverComponent,
    CardComponent,
    FilterComponent,
    BreadcrumbComponent,
    FileIconComponent,
    ContactCardComponent,
    DocumentCardComponent,
    ProgressIndicatorComponent,
    CircleImageInputComponent,
    NgbDateToIsoPipe,
    DeleteConfirmComponent,
    VersionComponent,
    NoteEnergieComponent,
    ClasseEnergetiquePipe,
    UcfirstPipe,
    OpenLocataireConfirmComponent,
    NousContacterComponent,
    ConfirmComponent,
    OffrePartenaireCardComponent,
    BadeauComponent,
  ],
  exports: [
    MenuComponent,
    MenuMobileComponent,
    ToastsComponent,
    ReferentielPipe,
    ReferentielComponent,
    BackResourcePipe,
    ExcerptPipe,
    GroupByPipe,
    JoinPipe,
    FileExtensionPipe,
    TypeofPipe,
    BypassSecurityTrustUrlPipe,
    AdresseComponent,
    RowItemComponent,
    RowContainerComponent,
    CoverComponent,
    CardComponent,
    FilterComponent,
    BreadcrumbComponent,
    FileIconComponent,
    ContactCardComponent,
    DocumentCardComponent,
    ProgressIndicatorComponent,
    CircleImageInputComponent,
    NgbDateToIsoPipe,
    DeleteConfirmComponent,
    VersionComponent,
    NoteEnergieComponent,
    ClasseEnergetiquePipe,
    UcfirstPipe,
    OpenLocataireConfirmComponent,
    FileSizePipe,
    ConfirmComponent,
    OffrePartenaireCardComponent,
    BadeauComponent,
  ],
  imports: [
    CommonModule,
    NgbToastModule,
    ReactiveFormsModule,
    NgbTypeaheadModule,
    FormsModule,
    FontAwesomeModule,
    RouterModule,
    NgbDropdownModule,
    NgxMatomoTrackerModule,
    NgxEditorModule,

  ]
})
export class ComponentsModule {
}
